import styled from "@emotion/styled";
import AtomicTag from "global/components/atomic/Tag";

export const Tag = styled(AtomicTag)`
  flex-shrink: 0;
  transform: translateY(3px);
`;
